/**
 * AddAllowlistForm — add an email or domain to the runtime admin allowlist.
 */
import React from "react";
import { Plus } from "lucide-react";

const ADD_ROLES = [
  { value: "sales_person", label: "Sales person — assessments + own pipeline" },
  { value: "sales_manager", label: "Sales manager — full pipeline + assessments" },
  { value: "trial_user", label: "Trial user — time-limited, no admin menu" },
  { value: "campaign_user", label: "Campaign user — one-off, no admin menu" },
];

export default function AddAllowlistForm({ addType, setAddType, addValue, setAddValue, addRole, setAddRole, adding, onSubmit }) {
  return (
    <form
      onSubmit={onSubmit}
      className="bg-white border border-zinc-200 p-5 lg:p-6 mb-10 flex flex-wrap items-end gap-4"
      data-testid="users-add-form"
    >
      <label className="block">
        <span className="text-[11px] font-medium tracking-[0.16em] text-zinc-500 uppercase">Type</span>
        <select
          value={addType}
          onChange={(e) => setAddType(e.target.value)}
          className="mt-2 border border-zinc-300 px-3 py-2 text-[14px] bg-white"
          data-testid="users-add-type"
        >
          <option value="email">Email</option>
          <option value="domain">Domain</option>
        </select>
      </label>
      <label className="block flex-1 min-w-[240px]">
        <span className="text-[11px] font-medium tracking-[0.16em] text-zinc-500 uppercase">
          {addType === "email" ? "Email address" : "Domain (no @)"}
        </span>
        <input
          type="text"
          value={addValue}
          onChange={(e) => setAddValue(e.target.value)}
          placeholder={addType === "email" ? "an.other@ekselens.com" : "ekselens.com"}
          required
          maxLength={200}
          className="mt-2 w-full border border-zinc-300 px-3 py-2 text-[14px]"
          data-testid="users-add-value"
        />
      </label>
      {addType === "email" && (
        <label className="block min-w-[260px]">
          <span className="text-[11px] font-medium tracking-[0.16em] text-zinc-500 uppercase">Role / access</span>
          <select
            value={addRole}
            onChange={(e) => setAddRole(e.target.value)}
            className="mt-2 w-full border border-zinc-300 px-3 py-2 text-[14px] bg-white"
            data-testid="users-add-role"
          >
            {ADD_ROLES.map((r) => (
              <option key={r.value} value={r.value}>{r.label}</option>
            ))}
          </select>
        </label>
      )}
      <button
        type="submit"
        disabled={adding || !addValue.trim()}
        className="ek-btn ek-btn-primary text-[12.5px] disabled:opacity-50"
        data-testid="users-add-submit"
      >
        <Plus size={13} /> {adding ? "Adding…" : "Add to allowlist"}
      </button>
      {addType === "domain" && (
        <p className="w-full text-[12px] text-amber-700 bg-amber-50 border border-amber-200 px-3 py-2" data-testid="users-add-domain-warning">
          ⚠ Anyone with an email on a trusted domain is granted <strong>full founder access</strong> by default. Prefer adding individual emails with a specific role.
        </p>
      )}
    </form>
  );
}
